/**
 * 模块名称: 客户名称变更审批
 * @author zhuyan@372163.com
 */

// import '../assets/style.scss'
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import NameChangeAudit from './NameChangeAudit'
import NameChangeDetail from './NameChangeDetail'

const NameChangeAuditIndex = ({ match, history }) => {

  return (
    <div>
      <Switch>
        <Route path={match.path + '/detail'} component={NameChangeDetail} />
        <Route component={NameChangeAudit} />
      </Switch>
    </div>
  )
}

export default NameChangeAuditIndex